module.exports = __webpack_public_path__ + "img/the-gentlemen.76e4be5b.jpg";